import $ from "jquery";
// v2 exposes only the package root through its `exports` map (the v1 deep path
// `devbridge-autocomplete/dist/jquery.autocomplete` no longer resolves). The module
// installs $.fn.autocomplete on the shared jQuery instance as a load-time side effect.
import "devbridge-autocomplete";

const getElementOrNull = function (selector) {
  return selector ? $(selector)[0] : null;
};

const escapeRegExp = function (text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};

const attachAutocomplete = function () {
  const $input = $(this);
  const serviceUrl = $input.data("autocomplete-url");
  const groupBy = $input.data("autocomplete-group-by");
  const params = $input.data("params");
  const hiddenField = getElementOrNull($input.data("autocomplete-hidden-field"));
  const $hiddenField = $(hiddenField);
  const $resetLink = $input.closest(".autocomplete-container").find(".autocomplete-reset");

  if (!serviceUrl) {
    // eslint-disable-next-line no-console
    console.warn("Autocomplete specified with no service URL");
    return;
  }

  const customOrganisationsTransactionsAutocomplete = $input.closest(".transaction-organisation-autocomplete").length > 0;
  const customOrganisationsTransactionsProfileAutocomplete = $input.closest(".transaction-organisation-profile-autocomplete").length > 0;

  const customOrganisationsOwnershipAutocomplete = $input.closest(".ownership-organisation-autocomplete").length > 0;

  const $transactionFormContainer = $input.closest(".nested-fields");
  const $transactionFormOrgNameInput = $transactionFormContainer.find("input.transaction-organisation-organisation-name");
  const $transactionFormProfileOrgNameInput = $transactionFormContainer.find("input.transaction-organisation-profile-organisation-name");
  const $transactionFormCountrySelect = $transactionFormContainer.find("select.transaction-organisation-country-name");
  const $ownershipFormOrganisationInput = $transactionFormContainer.find("input.ownership-organisation-name");

  let selectedSuggestionValue;
  if ($hiddenField.val()) {
    selectedSuggestionValue = $input.val();
  }

  $input.autocomplete({
    params: { extra_query: params },
    serviceUrl: serviceUrl,
    forceFixPosition: true,
    noCache: true,
    width: "flex",
    groupBy: groupBy,
    showNoSuggestionNotice: true,
    formatResult: function (suggestion, currentValue) { // copied and modified from source
      // Do not replace anything if the current value is empty
      if (!currentValue) {
        return suggestion.value;
      }

      const pattern = `(${escapeRegExp(currentValue)})`;

      const base = suggestion.value
        .replace(new RegExp(pattern, "gi"), "<strong>$1<\/strong>")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/&lt;(\/?strong)&gt;/g, "<$1>");

      if (!suggestion.data.highlight) {
        return base;
      }

      return `<span class="highlight">${base}</span>`;
    },
    onSelect: function (suggestion) {
      selectedSuggestionValue = suggestion.value;

      if (suggestion.data.value) {
        $input.val(suggestion.data.value);
      }

      if (customOrganisationsTransactionsAutocomplete) {
        const countryId = suggestion.data.country_id;

        if (countryId) {
          $transactionFormCountrySelect.prop("disabled", true);
          $transactionFormCountrySelect.val(countryId);
          $transactionFormCountrySelect.trigger("change");

          $transactionFormOrgNameInput.val("");
        } else {
          // must be a bit of custom text then
          $transactionFormCountrySelect.prop("disabled", false);
          $transactionFormCountrySelect.val("");
          $transactionFormCountrySelect.trigger("change");

          $transactionFormOrgNameInput.val(suggestion.value);
        }
      }

      if (customOrganisationsTransactionsProfileAutocomplete) {
        $transactionFormProfileOrgNameInput.val("");
      }

      if (customOrganisationsOwnershipAutocomplete) {
        $ownershipFormOrganisationInput.val("");
      }

      if (suggestion.data.url) {
        window.Navigation.goToHref(suggestion.data.url);
      } else if (hiddenField && suggestion.data.id) {
        $hiddenField.prop("value", suggestion.data.id);
        $hiddenField.closest(".autocomplete-container").find(".autocomplete-id-display").text(suggestion.data.id + "-" + (suggestion.data.lead ? "lead" : "not lead"));
        $hiddenField.attr("data-url-id-value", suggestion.data.url_id || suggestion.data.id);
        $hiddenField.trigger("autocomplete.done");
      } else if (suggestion.data.stringToPaste) {
        $input.trigger("input"); // SI: meant to work alongside my_waterdata.js on the favourites page
      }
    }
  });

  const partiallyResetCustomNameTransactionOrganisationAutocomplete = function () {
    if (!customOrganisationsTransactionsAutocomplete) { return; }
    if (selectedSuggestionValue && $input.val() === selectedSuggestionValue) { return; }

    const value = $input.val();
    selectedSuggestionValue = null;
    $resetLink.click();

    $input.val(value);

    $transactionFormCountrySelect.prop("disabled", false);
    $transactionFormOrgNameInput.val(value);
  };

  const partiallyResetCustomNameTransactionOrganisationProfileAutocomplete = function () {
    if (!customOrganisationsTransactionsProfileAutocomplete) { return; }
    if (selectedSuggestionValue && $input.val() === selectedSuggestionValue) { return; }

    const value = $input.val();
    selectedSuggestionValue = null;
    $resetLink.click();

    $input.val(value);

    $transactionFormProfileOrgNameInput.val(value);
  };

  const partiallyResetCustomNameOwnershipOrganisationAutocomplete = function () {
    if (!customOrganisationsOwnershipAutocomplete) { return; }
    if (selectedSuggestionValue && $input.val() === selectedSuggestionValue) { return; }

    const value = $input.val();
    selectedSuggestionValue = null;
    $resetLink.click();

    $input.val(value);

    $ownershipFormOrganisationInput.val(value);
  };

  // If the user hits enter or leaves the field assume they are done searching and want to see some sort of response.
  const blurOrEnter = function () {
    if (!$input.val()) { $resetLink.click(); }

    partiallyResetCustomNameTransactionOrganisationAutocomplete();
    partiallyResetCustomNameTransactionOrganisationProfileAutocomplete();
    partiallyResetCustomNameOwnershipOrganisationAutocomplete();
  };

  $input.blur(blurOrEnter);

  $input.keyup(function (e) {
    if (!selectedSuggestionValue) {
      if (customOrganisationsTransactionsAutocomplete) $transactionFormOrgNameInput.val($input.val());
      if (customOrganisationsTransactionsProfileAutocomplete) $transactionFormProfileOrgNameInput.val($input.val());

      $ownershipFormOrganisationInput.val($input.val());
    }
    if (e.which !== 13) {
      return;
    }

    blurOrEnter();
  });
};

$(document).on("turbolinks:load", function () {
  $("[data-autocomplete]").each(attachAutocomplete);
});

$(document).on("cocoon:after-insert", function (e, insertedItem) {
  const $insertedItem = $(insertedItem);

  $insertedItem.find(".autocomplete-container").each(function () {
    const $this = $(this);
    const rando = ("id-" + Math.random()).replace(".", "");

    $this.find(".autocomplete-target").prop("id", rando).attr("id", rando);

    window.setTimeout(function () {
      $this.find("[data-autocomplete]")
           .data("autocompleteHiddenField", "#" + rando)
           .attr("data-autocomplete-hidden-field", "#" + rando)
           .each(attachAutocomplete);
    }, 0);
  });
});
